/**
 * Default filter and sorting configurations per route/page
 * These are applied when no user preferences exist
 */

export interface FilterConfig {
  filters: Array<{
    id: string;
    operator: string;
    value: string;
    enabled: boolean;
  }>;
  sorting: Array<{
    id: string;
    direction: 'asc' | 'desc';
    enabled: boolean;
  }>;
}

export const DEFAULT_CONFIGS: Record<string, FilterConfig> = {
  // User ratings page: prioritize by my_rating, then average, then year
  userRatings: {
    filters: [],
    sorting: [
      { id: 'my_rating', direction: 'desc', enabled: true },
      { id: 'average_rating', direction: 'desc', enabled: true },
      { id: 'release_year', direction: 'desc', enabled: true },
    ],
  },

  // Default for all other pages
  default: {
    filters: [],
    sorting: [
      { id: 'average_rating', direction: 'desc', enabled: true },
      { id: 'release_year', direction: 'desc', enabled: true },
    ],
  },
};

/**
 * Determine which default config to use based on current route
 */
export function getDefaultConfigForRoute(
  pathname: string,
  username?: string,
): FilterConfig {
  const isMyRatingsPage =
    pathname.includes('/u/') && pathname.endsWith('/ratings');

  if (isMyRatingsPage) {
    return DEFAULT_CONFIGS.userRatings;
  }

  return DEFAULT_CONFIGS.default;
}
